module.exports = __webpack_public_path__ + "img/premio8.580a199d.jpeg";